import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';

import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';

export interface IBaasCheckboxHeaderParams<TData = any> extends IHeaderParams {
    /** Whether the given row is eligible for being targetted by the header checkbox. */
    rowEligible?: (data: TData) => boolean;
}

@Component({
    selector: 'baas-header-checkbox',
    template: `
        <mat-checkbox [(ngModel)]="checked" [indeterminate]="indeterminate" (change)="onCheckboxChange($event)">{{ params.displayName }}</mat-checkbox>
    `,
    standalone: true,
    imports: [MatCheckbox, FormsModule],
    host: { class: 'baas-header-checkbox' }
})
/** @experimental Header component with a checkbox to check or uncheck the associated property in the array.  */
export class BaasCheckboxHeader implements IHeaderAngularComp {
    params!: IBaasCheckboxHeaderParams;
    checked = false;
    indeterminate = false;

    agInit(params: IBaasCheckboxHeaderParams): void {
        this.params = params;
        // Initial state based on rows that satisfy the condition
        this.#updateHeaderCheckboxState();
        // Listen for changes in the grid's data
        this.params.api.addEventListener('cellValueChanged', this.#onCellValueChanged.bind(this));
        this.params.api.addEventListener('rowDataUpdated', this.#updateHeaderCheckboxState.bind(this));
        this.params.api.addEventListener('sortChanged', this.#updateHeaderCheckboxState.bind(this));
        this.params.api.addEventListener('paginationChanged', this.#updateHeaderCheckboxState.bind(this));
        this.params.api.addEventListener('filterChanged', this.#updateHeaderCheckboxState.bind(this));
    }

    refresh(params: any): boolean {
        this.params = params;
        return true;
    }

    onCheckboxChange(event: any) {
        const isChecked = event.checked;
        const colId = this.params.column.getColId();

        this.params.api.getRenderedNodes().forEach((node) => {
            if (node.data && (!this.params.rowEligible || this.params.rowEligible(node.data))) {
                node.setDataValue(colId, isChecked);
            }
        });

        this.checked = isChecked;
        this.indeterminate = false;
    }

    #onCellValueChanged(event: any) {
        const field = this.params.column.getColDef().field;
        if (event.colDef.field === field) {
            this.#updateHeaderCheckboxState();
        }
    }

    #updateHeaderCheckboxState() {
        const rows = this.params.api.getRenderedNodes().filter((node) => !this.params.rowEligible || this.params.rowEligible(node.data));
        const field = this.params.column.getColDef().field;
        const allChecked = rows.every((node) => node.data[field] === true);
        const someChecked = rows.some((node) => node.data[field] === true);

        this.checked = allChecked;
        this.indeterminate = !allChecked && someChecked;
    }
}
